import type { JSX } from "react";

import Grid from "@mui/material/Grid2";
import {
  ThumbnailControlProps,
  useThumbnailControlLayoutProps,
  useVisibleAttributeValues,
} from "@plansoft-configuration-renderer/components";
import { CsValueController } from "@plansoft-configuration-renderer/framework";

import { ThumbnailItem } from "./ThumbnailItem";

interface CustomLayoutProps {
  custom: {
    renderAsSwitch?: boolean;
    renderAsCustomThumbnail?: boolean;
  };
}

/**
 * Thumbnail control
 * @category UI
 * @param props
 * @returns
 */
export function CustomThumbnailControl(
  props: ThumbnailControlProps & Partial<CustomLayoutProps>,
): JSX.Element {
  const values = useVisibleAttributeValues();
  const renderAsSwitch = props.custom?.renderAsSwitch ?? false;
  const renderAsCustomThumbnail =
    props.custom?.renderAsCustomThumbnail ?? false;

  const { gridSpacing, gridDirection, gridBreakpoints } =
    useThumbnailControlLayoutProps();

  const className = renderAsSwitch
    ? "renderAsSwitch"
    : renderAsCustomThumbnail
      ? "renderAsCustomThumbnail"
      : "";

  return (
    <Grid
      container
      direction={gridDirection}
      spacing={gridSpacing}
      sx={{ justifyContent: renderAsCustomThumbnail ? "center" : "inherit" }}
    >
      {values.map((value) => (
        <Grid key={value.id} size={gridBreakpoints} className={className}>
          <CsValueController value={value}>
            <ThumbnailItem>{props.children}</ThumbnailItem>
          </CsValueController>
        </Grid>
      ))}
    </Grid>
  );
}
